import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "../actionCreators";

type Args = {
  kitId: string;
  spaceId: number;
  name: string;
  notes?: string;
};

const [useCreateKitVersion, createKitVersion] = createAsyncAction(
  "kitVersion/create",
  async (args: Args) => {
    const res = await API.call<{ kitVersion: string }>({
      endpoint: `kits/${args.kitId}/version`,
      method: "POST",
      data: {
        version_identifier: args.name,
        notes: args.notes || "",
      },
    });
    return { ...res, result: res.result.kitVersion };
  }
);

export default useCreateKitVersion;
export { createKitVersion };
